(function () {

    'use strict';

    angular.module('asys')
        .component('asysAntragPruefenWichtigeHinweise', {
            templateUrl: 'reiter/antragpruefen/antragPruefenWichtigeHinweise.html',
            controller: AntragPruefenWichtigeHinweiseController,
            controllerAs: 'antragPruefenWichtigeHinweiseVm'
        });

    AntragPruefenWichtigeHinweiseController.$inject = [
        'AngebotModel'
    ];
    function AntragPruefenWichtigeHinweiseController(AngebotModel) {
        var vm = this;

        vm.$onInit = onInit;

        function activate() {
            vm.angebotModel = AngebotModel.get();
        }

        function onInit() {
            activate();
        }
    }

})();
